/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _slicedToArray } from '../_chunks/dep-e43cf21c.js';
import { _ as _defineProperty } from '../_chunks/dep-46de7b2e.js';
import React, { forwardRef, useRef } from 'react';
import classNames from 'classnames';
import { i as isFunction_1 } from '../_chunks/dep-f10515e8.js';
import { CaretRightSmallIcon } from 'tdesign-icons-react';
import { Loading } from '../loading/index.js';
import useRipple from '../_util/useRipple.js';
import useDomRefCallback from '../hooks/useDomRefCallback.js';
import useGlobalIcon from '../hooks/useGlobalIcon.js';
import { Checkbox } from '../checkbox/index.js';
import { useTreeConfig } from './useTreeConfig.js';
import useDraggable from './useDraggable.js';
import composeRefs from '../_util/composeRefs.js';
import useConfig from '../hooks/useConfig.js';
import '../_chunks/dep-2acfafca.js';
import '../_chunks/dep-c3f1141e.js';
import '../_chunks/dep-4941ebe7.js';
import '../_chunks/dep-e9b62d1f.js';
import '../_chunks/dep-88cd50bf.js';
import '../loading/Loading.js';
import '../_util/dom.js';
import 'raf';
import '../_chunks/dep-6c5254c6.js';
import '../_chunks/dep-77e34309.js';
import '../_chunks/dep-7dce2c26.js';
import '../_util/easing.js';
import '../common/Portal.js';
import 'react-dom';
import '../config-provider/ConfigContext.js';
import '../_chunks/dep-d71ee5f3.js';
import '../_chunks/dep-4b8f240e.js';
import '../_chunks/dep-9acbc163.js';
import '../_chunks/dep-7b52f080.js';
import '../_chunks/dep-dcb5aa2a.js';
import '../_chunks/dep-ee4bf8c2.js';
import '../_chunks/dep-934eda0c.js';
import '../_chunks/dep-12510d64.js';
import '../_chunks/dep-6b568d83.js';
import '../_chunks/dep-304e657b.js';
import '../_chunks/dep-6506fbc2.js';
import '../_chunks/dep-bb5d7b1e.js';
import '../_chunks/dep-e285f2f8.js';
import '../_chunks/dep-f4a320cd.js';
import '../_chunks/dep-ec70b95c.js';
import '../locale/zh_CN.js';
import '../_common/js/global-config/locale/zh_CN.js';
import 'dayjs';
import '../_chunks/dep-cbcc9f89.js';
import '../_common/js/global-config/default-config.js';
import '../loading/gradient.js';
import '../_common/js/loading/circle-adapter.js';
import '../_common/js/utils/set-style.js';
import '../_common/js/utils/helper.js';
import '../_chunks/dep-fd3498b6.js';
import '../_chunks/dep-92728dc5.js';
import '../_chunks/dep-ec16db36.js';
import '../_chunks/dep-036ad2cc.js';
import '../_chunks/dep-0e15088f.js';
import '../loading/defaultProps.js';
import '../loading/plugin.js';
import '../_util/react-render.js';
import '../_chunks/dep-e0370ebe.js';
import '../loading/style/css.js';
import '../loading/type.js';
import '../_util/useAnimation.js';
import '../_util/setStyle.js';
import '../_chunks/dep-e3db8410.js';
import '../_util/forwardRefWithStatics.js';
import 'hoist-non-react-statics';
import '../common/Check.js';
import '../_chunks/dep-7dad86aa.js';
import '../_util/helper.js';
import '../_chunks/dep-2ffb6f37.js';
import '../_chunks/dep-33ffecad.js';
import '../_chunks/dep-c1f93350.js';
import '../_chunks/dep-f721d103.js';
import '../_chunks/dep-4559db64.js';
import '../_chunks/dep-c00532d4.js';
import '../_chunks/dep-08c1f545.js';
import '../hooks/useControlled.js';
import '../_util/noop.js';
import '../checkbox/defaultProps.js';
import '../checkbox/style/css.js';
import '../checkbox/type.js';
import '../locale/LocalReceiver.js';
import '../config-provider/index.js';
import '../config-provider/ConfigProvider.js';
import '../_chunks/dep-b0a01ce1.js';
import '../_chunks/dep-01ce608f.js';
import '../_chunks/dep-77a54538.js';
import './TreeDraggableContext.js';
import '../_util/createHookContext.js';
import '../_util/usePersistFn.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var TreeItem = /*#__PURE__*/forwardRef(function (props, ref) {
  var _classNames4;
  var node = props.node,
    icon = props.icon,
    label = props.label,
    line = props.line,
    expandOnClickNode = props.expandOnClickNode,
    activable = props.activable,
    checkProps = props.checkProps,
    disableCheck = props.disableCheck,
    operations = props.operations,
    onClick = props.onClick,
    _onChange = props.onChange;
  var _useGlobalIcon = useGlobalIcon({
      CaretRightSmallIcon: CaretRightSmallIcon
    }),
    CaretRightSmallIcon$1 = _useGlobalIcon.CaretRightSmallIcon;
  var level = node.level;
  var _useTreeConfig = useTreeConfig(),
    treeClassNames = _useTreeConfig.treeClassNames,
    locale = _useTreeConfig.locale;
  var _useConfig = useConfig(),
    classPrefix = _useConfig.classPrefix;
  var handleClick = function handleClick(evt) {
    var _srcTarget$className, _srcTarget$className$;
    var srcTarget = evt.target;
    var isBranchTrigger = node.children && expandOnClickNode && (srcTarget.className === "".concat(classPrefix, "-checkbox__input") || srcTarget.tagName.toLowerCase() === "input");
    if (isBranchTrigger) return;
    if (expandOnClickNode && node.children && ((_srcTarget$className = srcTarget.className) === null || _srcTarget$className === void 0 ? void 0 : (_srcTarget$className$ = _srcTarget$className.indexOf) === null || _srcTarget$className$ === void 0 ? void 0 : _srcTarget$className$.call(_srcTarget$className, "".concat(classPrefix, "-tree__label"))) !== -1) evt.preventDefault();
    onClick === null || onClick === void 0 ? void 0 : onClick(node, {
      e: evt,
      expand: expandOnClickNode,
      active: activable,
      trigger: "node-click"
    });
  };
  var handleItemClick = function handleItemClick(evt) {
    if (node.loading) {
      return;
    }
    onClick === null || onClick === void 0 ? void 0 : onClick(node, {
      e: evt,
      expand: true,
      active: false,
      trigger: "icon-click"
    });
  };
  var handleIconClick = function handleIconClick(evt) {
    evt.stopPropagation();
    handleItemClick(evt);
  };
  var stopPropagation = function stopPropagation(e) {
    e.stopPropagation();
  };
  var renderIcon = function renderIcon() {
    var isDefaultIcon = false;
    var renderIconNode = function renderIconNode() {
      if (icon === false) {
        return null;
      }
      if (icon instanceof Function) {
        return icon(node.getModel());
      }
      if ( /*#__PURE__*/React.isValidElement(icon)) {
        return icon;
      }
      if (icon && icon !== true) {
        throw new Error("invalid type of icon");
      }
      if (!node.isLeaf()) {
        isDefaultIcon = true;
        if (node.loading && node.expanded) {
          return /* @__PURE__ */React.createElement(Loading, {
            loading: true
          });
        }
        return /* @__PURE__ */React.createElement(CaretRightSmallIcon$1, {
          className: treeClassNames.treeIconRight
        });
      }
      return null;
    };
    var iconNode = renderIconNode();
    return /* @__PURE__ */React.createElement("span", {
      className: classNames(treeClassNames.treeIcon, treeClassNames.folderIcon, _defineProperty({}, treeClassNames.treeIconDefault, isDefaultIcon)),
      onClick: handleIconClick
    }, iconNode);
  };
  var renderLine = function renderLine() {
    var iconVisible = icon !== false;
    if (line === false) {
      return null;
    }
    if (isFunction_1(line)) {
      return line(node.getModel());
    }
    if ( /*#__PURE__*/React.isValidElement(line)) {
      return line;
    }
    if (node.parent && node.tree) {
      var _classNames2;
      var shadowStyles = [];
      var parents = node.getParents();
      parents.pop();
      parents.forEach(function (pnode, index) {
        if (!pnode.vmIsLast) {
          shadowStyles.push("calc(-".concat(index + 1, " * var(--space)) 0 var(--color)"));
        }
      });
      var styles = {
        "--level": level,
        boxShadow: shadowStyles.join(",")
      };
      return /* @__PURE__ */React.createElement("span", {
        className: classNames(treeClassNames.line, (_classNames2 = {}, _defineProperty(_classNames2, treeClassNames.lineIsLeaf, node.vmIsLeaf || !iconVisible), _defineProperty(_classNames2, treeClassNames.lineIsFirst, node.vmIsFirst && iconVisible), _classNames2)),
        style: styles,
        onClick: stopPropagation
      });
    }
    return null;
  };
  var _useDomRefCallback = useDomRefCallback(),
    _useDomRefCallback2 = _slicedToArray(_useDomRefCallback, 2),
    labelDom = _useDomRefCallback2[0],
    setRefCurrent = _useDomRefCallback2[1];
  useRipple(labelDom);
  var renderLabel = function renderLabel() {
    var _node$data;
    var emptyView = locale("empty");
    var labelText = "";
    if (label instanceof Function) {
      labelText = label(node.getModel()) || emptyView;
    } else {
      labelText = node.label || emptyView;
    }
    var labelClasses = classNames(treeClassNames.treeLabel, treeClassNames.treeLabelStrictly, _defineProperty({}, treeClassNames.actived, node.isActivable() ? node.actived : false));
    if (node.isCheckable()) {
      var checkboxDisabled;
      if (typeof disableCheck === "function") {
        checkboxDisabled = disableCheck(node.getModel());
      } else {
        checkboxDisabled = !!disableCheck;
      }
      if (node.isDisabled()) {
        checkboxDisabled = true;
      }
      return /* @__PURE__ */React.createElement(Checkbox, _objectSpread({
        ref: setRefCurrent,
        checked: node.checked,
        indeterminate: node.indeterminate,
        disabled: checkboxDisabled,
        name: String(node.value),
        onChange: function onChange(checked, ctx) {
          return _onChange(node, ctx);
        },
        className: labelClasses,
        stopLabelTrigger: !!node.children
      }, checkProps), /* @__PURE__ */React.createElement("span", {
        "date-target": "label"
      }, labelText));
    }
    return /* @__PURE__ */React.createElement("span", {
      ref: setRefCurrent,
      "date-target": "label",
      className: labelClasses,
      title: String(((_node$data = node.data) === null || _node$data === void 0 ? void 0 : _node$data.text) || node.label)
    }, /* @__PURE__ */React.createElement("span", {
      style: {
        position: "relative"
      }
    }, labelText));
  };
  var renderOperations = function renderOperations() {
    var operationsView = null;
    if (operations) {
      if ( /*#__PURE__*/React.isValidElement(operations)) {
        operationsView = operations;
      } else if (operations instanceof Function) {
        var treeNodeModel = node === null || node === void 0 ? void 0 : node.getModel();
        operationsView = operations(treeNodeModel);
      } else {
        throw new Error("invalid type of operations");
      }
    }
    if (operationsView) {
      return /* @__PURE__ */React.createElement("span", {
        className: treeClassNames.treeOperations,
        "date-target": "operations"
      }, operationsView);
    }
    return null;
  };
  var nodeRef = useRef(null);
  var _useDraggable = useDraggable({
      node: node,
      nodeRef: nodeRef
    }),
    setDragStatus = _useDraggable.setDragStatus,
    isDragging = _useDraggable.isDragging,
    dropPosition = _useDraggable.dropPosition,
    isDragOver = _useDraggable.isDragOver;
  var handleDragStart = function handleDragStart(evt) {
    var node2 = props.node;
    if (!node2.isDraggable()) return;
    evt.stopPropagation();
    setDragStatus("dragStart", evt);
    try {
      var _evt$dataTransfer;
      (_evt$dataTransfer = evt.dataTransfer) === null || _evt$dataTransfer === void 0 ? void 0 : _evt$dataTransfer.setData("text/plain", "");
    } catch (e) {}
  };
  var handleDragEnd = function handleDragEnd(evt) {
    var node2 = props.node;
    if (!node2.isDraggable()) return;
    evt.stopPropagation();
    setDragStatus("dragEnd", evt);
  };
  var handleDragOver = function handleDragOver(evt) {
    var node2 = props.node;
    if (!node2.isDraggable()) return;
    evt.stopPropagation();
    evt.preventDefault();
    setDragStatus("dragOver", evt);
  };
  var handleDragLeave = function handleDragLeave(evt) {
    var node2 = props.node;
    if (!node2.isDraggable()) return;
    evt.stopPropagation();
    setDragStatus("dragLeave", evt);
  };
  var handleDrop = function handleDrop(evt) {
    var node2 = props.node;
    if (!node2.isDraggable()) return;
    evt.stopPropagation();
    evt.preventDefault();
    setDragStatus("drop", evt);
  };
  return /* @__PURE__ */React.createElement("div", {
    ref: composeRefs(ref, nodeRef),
    "data-value": node.value,
    "data-level": level,
    className: classNames(treeClassNames.treeNode, (_classNames4 = {}, _defineProperty(_classNames4, treeClassNames.treeNodeOpen, node.expanded), _defineProperty(_classNames4, treeClassNames.actived, node.isActivable() ? node.actived : false), _defineProperty(_classNames4, treeClassNames.disabled, node.isDisabled()), _defineProperty(_classNames4, treeClassNames.treeNodeDraggable, node.isDraggable()), _defineProperty(_classNames4, treeClassNames.treeNodeDragging, isDragging), _defineProperty(_classNames4, treeClassNames.treeNodeDragTipTop, isDragOver && dropPosition < 0), _defineProperty(_classNames4, treeClassNames.treeNodeDragTipBottom, isDragOver && dropPosition > 0), _defineProperty(_classNames4, treeClassNames.treeNodeDragTipHighlight, !isDragging && isDragOver && dropPosition === 0), _classNames4)),
    style: {
      "--level": level,
      boxShadow: ""
    },
    onClick: handleClick,
    draggable: node.isDraggable(),
    onDragStart: handleDragStart,
    onDragEnd: handleDragEnd,
    onDragOver: handleDragOver,
    onDragLeave: handleDragLeave,
    onDrop: handleDrop
  }, renderLine(), renderIcon(), renderLabel(), renderOperations());
});
TreeItem.displayName = "TreeItem";

export { TreeItem as default };
//# sourceMappingURL=TreeItem.js.map
